import faker from 'faker/locale/en';
export const fakeManagedEnterpriseId = faker.datatype.uuid();
export const fakeManagedOrgId = faker.datatype.uuid();